import { jsx as _jsx } from "react/jsx-runtime";
import { UserAttributeKeyDatePrecision } from '@iotv/datamodel-core';
import { AppValueTypes, Milliseconds, Networks, toEsp } from '@iotv/iotv-v3-types';
import React, { useEffect, useState } from 'react';
import { ShowDefinedEntriesOnlyOpts } from '../../../../types/AppTypes';
import { ObjectDetailCard } from '../../../../v2/components/generic/ObjectView/ObjectDetailCard';
const MessageDefinitions = {
    networkKey: {
        key: 'networkKey',
        type: AppValueTypes.ENUM,
        label: 'Application Server',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: Networks,
    },
    appID: { key: 'appID', type: AppValueTypes.STRING, label: 'App ID', editable: false },
    lastSeen: {
        key: 'lastSeen',
        type: AppValueTypes.DATE,
        label: 'Last Seen',
        editable: false,
        precision: UserAttributeKeyDatePrecision.DateTimeSecs,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
    lastSendPeriod: {
        key: 'lastSendPeriod',
        type: AppValueTypes.NUMBER,
        label: 'Message Period Actual',
        editable: false,
        precision: 2,
        stateFn: undefined,
        unit: 'minutes',
        validationRx: undefined,
        enumKV: undefined,
        valueGetter: (actualValue) => (actualValue ? actualValue / Milliseconds.MINUTE : undefined),
    },
    esp: {
        key: 'esp',
        type: AppValueTypes.NUMBER,
        label: 'ESP',
        editable: false,
        precision: 0,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
    isAWOL: {
        key: 'isAWOL',
        type: AppValueTypes.BOOLEAN,
        label: 'AWOL',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
    _permittedAWOL: {
        key: '_permittedAWOL',
        type: AppValueTypes.NUMBER,
        label: 'AWOL after',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: 'minutes',
        validationRx: undefined,
        enumKV: undefined,
        valueGetter: (actualValue) => (actualValue ? actualValue / Milliseconds.MINUTE : undefined),
    },
    fCnt: {
        key: 'fCnt',
        type: AppValueTypes.NUMBER,
        label: 'Frame Count',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
    messageFailureRate: {
        key: 'messageFailureRate',
        type: AppValueTypes.NUMBER,
        label: 'Failure Rate',
        editable: false,
        precision: 2,
        stateFn: undefined,
        unit: '%',
        validationRx: undefined,
        enumKV: undefined,
    },
};
const MessageData = (props) => {
    const { device, lns, transactionFunctions, userFunctions, mostProximateCustomer } = props;
    const [esp, setESP] = useState(undefined);
    const [extendedDevice, setExtendedDevice] = useState(null);
    useEffect(() => {
        if (device) {
            const espCal = toEsp(device.rssi, device.snr);
            setESP(espCal);
        }
        else {
            setESP(undefined);
        }
    }, [device]);
    useEffect(() => {
        setExtendedDevice({ ...device, esp, lnsName: lns?.name });
    }, [esp, device]);
    return (extendedDevice && (_jsx(ObjectDetailCard, { mostProximateCustomer,
        matchedPrimary: extendedDevice,
        transactionFunctions,
        userFunctions,
        definedEntriesOnlyOpt: ShowDefinedEntriesOnlyOpts.Yes,
        viewDefinition: MessageDefinitions,
        showContextSubCard: false })));
};
export default MessageData;
